/* eslint-disable no-multi-str */
/* eslint-disable import/prefer-default-export */
import { initializeFirebase } from "vit-timetable";

import { GOOGLE_CLIENT_ID } from "../config";

export const initializeGapiScript = () => {
  const script = document.createElement("script");
  const firebaseConfig = {
    apiKey: "AIzaSyAiERRKTtqLlRsElc8Tw5higjPqZuelR9w",
    authDomain: "timetable-to-calendar.firebaseapp.com",
    databaseURL:
      "https://timetable-to-calendar-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "timetable-to-calendar",
    storageBucket: "timetable-to-calendar.appspot.com",
    messagingSenderId: "516047975643",
    appId: "1:516047975643:web:ff029018dccf689f70c8fe",
  };
  function start() {
    window.gapi.client.init({
      clientId: GOOGLE_CLIENT_ID,
      discoveryDocs: [
        "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
      ],
      scope:
        "https://www.googleapis.com/auth/calendar.app.created\
      https://www.googleapis.com/auth/userinfo.profile \
      https://www.googleapis.com/auth/userinfo.email \
      openid",
    });
  }
  function loadClient() {
    window.gapi.load("client:auth2", start);
  }
  script.src = "https://apis.google.com/js/api.js";
  script.async = true;
  script.defer = true;
  script.onload = loadClient;
  document.body.append(script);
  initializeFirebase(firebaseConfig);
};

export const downloadCalendar = calendar => {
  const fileName = "calendar.ics";
  const downloadElement = document.createElement("a");
  downloadElement.setAttribute(
    "href",
    `data:text/plain;charset=utf-8,${encodeURIComponent(calendar)}`
  );
  downloadElement.setAttribute("download", fileName);
  downloadElement.click();
  window.open("https://calendar.google.com/calendar");
};
export const isFresher = registrationNum => {
  const currtime = new Date();
  const currYear = currtime.getFullYear() % 100;
  if (currtime.getMonth() >= 2 && currtime.getMonth() <= 7) {
    return currYear - registrationNum.getYear() === 1;
  }
  return currYear - registrationNum.getYear() === 0;
};
